module.exports = __webpack_public_path__ + "img/154.b987ea60.jpg";